import { LoginRequest, LoginResponse } from "../model";
import { apiClient } from "../../../shared/api/client";
import { publicClient } from "../../../shared/api/public-client";

/**
 * 인증 API: 순수 HTTP 통신만 담당
 * 백엔드와의 통신을 담당합니다
 */
class AuthAPI {
  /**
   * 로그인 API 호출
   * @param credentials 로그인 정보 (아이디, 비밀번호)
   * @returns 액세스 토큰, 리프레시 토큰, 사용자 정보
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await publicClient.post<LoginResponse>(
        `/auth/sign-in`,
        credentials
      );
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 회원가입 API 호출
   * @param signupData 회원가입 정보
   * @returns 회원가입 결과
   */
  async signup(signupData: any): Promise<LoginResponse> {
    try {
      const response = await publicClient.post<LoginResponse>(
        `/v1/users`,
        signupData
      );
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 로그아웃 API 호출
   */
  async logout(): Promise<void> {
    try {
      await apiClient.post(`/auth/sign-out`);
    } catch (err) {
      // 로그아웃 실패해도 클라이언트에서 정리
      console.warn("Logout API call failed:", err);
    }
  }

  /**
   * 토큰 갱신 API 호출
   * @param refreshToken 리프레시 토큰
   * @returns 새로운 액세스 토큰
   */
  async refreshToken(refreshToken: string): Promise<LoginResponse> {
    try {
      const response = await apiClient.post<LoginResponse>(
        `/auth/refresh-token`,
        { refreshToken }
      );
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 에러 처리
   */
  private handleError(err: any): Error {
    if (err.response?.data?.message) {
      return new Error(err.response.data.message);
    }
    if (err.message) {
      return new Error(err.message);
    }
    return new Error("API 호출 실패");
  }
}

export const authAPI = new AuthAPI();
